// extracted by mini-css-extract-plugin
module.exports = {"contact":"style-module--contact--RvLWW","adress":"style-module--adress--197Vk","email":"style-module--email--1Ht2W"};